import React, { Component, Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Header from "../Header";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import { create } from "../../../services/chapters";
import AppContext from "../../../contexts/AppContext";

export class CreateChapter extends Component {
    state = {
        item: {           
            title : '',           
            description: '',                      
            video: '',
            video_type: '',
            duration: '',
            resources: '',           
            course_name:'',         
            lesson_name:'',  
        },
        videoTypeList: [],
        imageArray : null,
        fileTypeError : false,
        fileSize : '',
        reading: [{title: "", link: ""}],   
        errors: {},         
    };

    handleVideoTypeSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.video_type = selectedOption.value;

        let error = this.state.errors;
        error.video_type = null;

        this.setState({ item: temp, errors: error });
    };
    
    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;       
        let error = this.state.errors;
        error[field.target.name] = null;   
        this.setState({ item: temp, errors: error });
    };

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.description = value;
        let error = this.state.errors;
        error.description = null;
        this.setState({ item: temp, errors: error });
    };

    getExtension(filename) {
        return filename.split('.').pop();
    }

    isFile(filename) {
        let ext = this.getExtension(filename);
        switch (ext.toLowerCase()) {
            case 'jpg':
            case 'gif':
            case 'bmp':
            case 'png':
            case 'pdf':
            case 'doc':
            case 'docx':
            case 'xlsx':
            //etc
            return true;
        }
        return false;
    }

    isDuration(totalDuration) {
        return /^\d{2}:\d{2}:\d{2}$/.test(totalDuration); 
    }

    isUrlValid(vdoUrl) {
        var regexQuery = "^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
        var url = new RegExp(regexQuery,"i");
        return url.test(vdoUrl);
    }

    fileChangedHandler = (event) => {   
        let files =  event.target.files;
        let errors = [];
        let size = [];
        for (var i = 0; i < files.length; i++) {
            //console.log(files[i].name);
            errors.push(this.isFile(files[i].name));
            size.push(files[i].size);           
        }   
        let totfileSize = size.reduce((a, b) => a + b);
        this.setState({ imageArray: event.target.files,fileTypeError: errors.every(element => element === true), fileSize: totfileSize});
    }   
    

    handleValidation(){
        let fields = this.state.item;
        let files = this.state.imageArray;
        let errors = {};
        let formIsValid = true;
        //console.log(fields);
        let FileSize = this.state.fileSize / 1024 / 1024; // in MB
          
        if(!fields.title){
            formIsValid = false;
            errors.title = "The title field is required.";
        }
       
        if(!fields.description){
            formIsValid = false;
            errors.description = "The description field is required.";
        }  
        
        if(!fields.video_type){
            formIsValid = false;
            errors.video_type = "The video type field is required.";
        } 

        if(!fields.video){
            formIsValid = false;
            errors.video = "The video field is required.";
        } 

        if(fields.video && !this.isUrlValid(fields.video))
        {
            formIsValid = false;
            errors.video = "Please enter valid video url.";
        }

        if(!fields.duration){
            formIsValid = false;
            errors.duration = "The video duration field is required.";
        } 

        
        if(fields.duration && !this.isDuration(fields.duration)){
            formIsValid = false;
            errors.duration = "Please enter in hh:mm:ss format.";
        } 

        if(files && files.length>5){
            formIsValid = false;
            errors.resources = "Maximum 5 files allowed to upload.";
        } 

        if(files && !this.state.fileTypeError){
            formIsValid = false;
            errors.resources = "Invalid file type.";
        } 

        if (files && FileSize > 10) {
            errors.company_image = "Total file size exceeds 10 MB";
        }
        
        this.setState({errors: errors});
        return formIsValid;
    }    

    handleSubmit = e => { 
        e.preventDefault();  
        //console.log(this.handleValidation());              
        if(this.handleValidation()){             
            const formData = new FormData();
            let files = this.state.imageArray;
            formData.append('cid', this.props.match.params.id) ; 
            formData.append('lid', this.props.match.params.lid);  
            formData.append('title',this.state.item.title);
            formData.append('description',this.state.item.description);
            formData.append('video',this.state.item.video); 
            formData.append('video_type',this.state.item.video_type);
            formData.append('duration',this.state.item.duration);
            if(files)
            {
                for (const files of this.state.imageArray) {
                    formData.append("file[]", files,files.name);
                } 
            }
            
            formData.append('reading', JSON.stringify(this.state.reading));  
            //console.log(this.state.imageArray);  
            create(formData)
            .then(response => {
                this.props.history.push(`/admin/courses/${this.props.match.params.id}/lessons/${this.props.match.params.lid}/chapters`);                
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });            
            
        } 
              
    };

    addClick (){        
        this.setState(prevState => ({ 
            reading: [...prevState.reading, { title: "", link: "" }]
        }))
    }

    removeClick(i){
        let reading = [...this.state.reading];
        reading.splice(i, 1);
        this.setState({ reading });
     }

    handleChange(i, e) {
        const { name, value } = e.target;
        let reading = [...this.state.reading];
        reading[i] = {...reading[i], [name]: value};
        this.setState({ reading });
     }    


    readingUI(){
        return this.state.reading.map((el, i) => (<div className="form-group row" key={i}>
            <div className="col-12 col-md-4">
                <label htmlFor="Reading">Title</label>
                <input placeholder="Reading Title" name="title" className="form-control" value={el.title || ''} onChange={this.handleChange.bind(this, i)} />
            </div>
            <div className="col-12 col-md-6">
                <label htmlFor="Reading">Link</label>
                <input placeholder="Reading Link" name="link" className="form-control" value={el.link || ''} onChange={this.handleChange.bind(this, i)} />
            </div>
            { i > 0 ? 
            <div className="col-12 col-md-2 mt-5">
                <a href='#' className='btn btn-sm btn-danger' onClick={this.removeClick.bind(this, i)}>Remove</a>
            </div> : <div className="col-12 col-md-2 mt-5"><a href='#' className='btn btn-sm btn-success' onClick={this.addClick.bind(this, i)}>Add</a> </div> }
        </div>))
     }



    componentDidMount() {  
        // listLessionRecord(this.props.match.params.lid)
        //     .then(response => {
                
        //     })
        //     .catch(error => {
        //         this.context.state.handelError(error);
        //     });
        this.setState({ videoTypeList: [
            {"id":'mp4',"value":'mp4',"name":'mp4 Employer',"label":'mp4'},
            {"id":'youtube',"value":'youtube',"name":'Youtube',"label":'Youtube'},
            
        ], item: {       
            course_name :'', 
            lesson_name : '',                                              
        } }); 

           
    }
    render() {
        return (
            <Fragment>
                <Header></Header>

                <div className="main-content mt-6">
                    <div className="container mt-3">
                        <div className="row justify-content-center">
                            <div
                                id="formModal"
                                className="col-12 col-lg-10 col-xl-8"
                            >
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                {/* <h6 className="header-pretitle">
                                                    Course Name : {this.state.item.course_name}
                                                </h6>
                                                <h6 className="header-pretitle">                                                    
                                                    Lesson Name : {this.state.item.lesson_name}
                                                </h6> */}
                                                <h1 className="header-title">
                                                    Add Chapter
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form data-select2-id="14" onSubmit={this.handleSubmit} encType={"multipart/form-data"}>                                    
                                    <div className="form-group">
                                        <label htmlFor="title">Title</label>
                                        <input
                                            id="title"
                                            name="title"
                                            onChange={this.onChange}
                                            value={this.state.item.title || '' }
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.title ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.title}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-6">
                                        <label
                                            className="mb-1"
                                            htmlFor="description"
                                        >
                                            Description
                                        </label>
                                        <small className="form-text text-muted">
                                                Describe chapter requirements.
                                        </small>
                                        <Quill
                                            style={{
                                                height: "200px"
                                            }}
                                            onChange={this.handleQuillChange}
                                            value={
                                                this.state.item
                                                    .description || ""
                                            }
                                        ></Quill>

                                        {this.state.errors.description ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.description}
                                            </div>
                                        ) : null}
                                    </div>                                          
                                                                   
                                    
                                    <div className="form-group row">
                                        
                                        
                                            <div className="form-group col-md-3">
                                        <label htmlFor="video_type">Video Type</label>
                                        <Select defaultValue={{ label: "Select", value: "" }}
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="video_type"
                                                id="video_type"
                                                placeholder="Select"
                                                onChange={
                                                    this
                                                        .handleVideoTypeSelectChange
                                                }
                                                options={
                                                    this.state.videoTypeList
                                                }
                                            ></Select>
                                        {this.state.errors.video_type ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.video_type}
                                            </div>
                                        ) : null}
                                        
                                    </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="video">Video (url)</label>
                                                <input
                                                    id="video"
                                                    name="video"
                                                    onChange={this.onChange}
                                                    value={this.state.item.video || '' }
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                />
                                                {this.state.errors.video ? (
                                                    <div className="invalid-feedback">
                                                        {this.state.errors.video}
                                                    </div>
                                                ) : null}
                                            </div> 
                                            <div className="form-group col-md-3">
                                                <label htmlFor="duration">Duration</label>                                                                                               
                                                <input type="text" placeholder="hh:mm:ss" name="duration" className="form-control" value={this.state.item.duration || ''} onChange={this.onChange} />
                                                {this.state.errors.duration ? (
                                                    <div className="invalid-feedback">
                                                        {this.state.errors.duration}
                                                    </div>
                                                ) : null}
                                            </div>        
                                    </div>   

                                    <div className="form-group">
                                        <label htmlFor="resources">Resources</label>
                                        <input
                                                    id="resources"
                                                    name="resources"                                           
                                                    onChange={this.fileChangedHandler}
                                                    type="file"
                                                    className="form-control"
                                                    multiple                                                    
                                                />

                                                {this.state.errors.resources ? (
                                                    <div className="text-danger">
                                                        {this.state.errors.resources}
                                                    </div>
                                                ) : null}
                                            
                                    </div> 
                                     
                                    {this.readingUI()}                                         
                                         
                                    <hr className="mt-5 mb-5" />
                                    <button className="newJob btn btn-block btn-primary text-white">Publish Chapter</button> 
                                    
                                    <div className=" btn-block center-text  mb-6 mt-3 d-flex justify-content-center">
                                        <Link
                                            to={`/admin/courses/${this.props.match.params.id}/lessons/${this.props.match.params.lid}/chapters`}
                                            className="btn btn-link text-muted"
                                        >
                                            Cancel
                                        </Link>
                                       
                                    </div>
                                </form>                                       
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

CreateChapter.contextType = AppContext;
export default CreateChapter;



// WEBPACK FOOTER //
// ./src/components/admin/chapters/Create.js